/**
 * Product naming, kept in one place so the service can be renamed without touching UI, server or
 * node code. Anything user-visible (page titles, headers, installer name, tray tooltip, cookie
 * display) must read from here instead of hard-coding a name.
 */
export const BRAND = {
    /** Display name shown in the web UI */
    name: 'VOS Bridge',
    /** Program slug in vos-tools: license grant key and release/feed program id */
    slug: 'vos-bridge',
    /** Installed desktop node product name; also the base of the installer file name */
    nodeName: 'VOS Bridge Node',
    /** Reverse-DNS application id for the desktop node */
    appId: 'kr.proswin.vos-bridge',
};
//# sourceMappingURL=branding.js.map